import { useEffect, useState } from "react";
import { Users } from "lucide-react";

import MockBadge from "@/components/MockBadge";
import { admin } from "@/lib/api";
import { fmtTime, fmtUSD } from "@/lib/format";

export default function Clients() {
  const [rows, setRows] = useState([]);
  useEffect(() => { admin.clients().then(setRows).catch(() => {}); }, []);

  return (
    <div data-testid="page-clients" className="p-6 md:p-10">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
        <div className="min-w-0">
          <div className="pj-label mb-2">· ECHO · CRM & retention</div>
          <h1 className="font-display text-[32px] md:text-[40px] leading-[1.02] truncate">Clients</h1>
        </div>
        <div className="flex-shrink-0">
          <MockBadge />
        </div>
      </div>

      <div className="pj-card overflow-x-auto">
        <table className="w-full mono text-[12px]">
          <thead style={{ color: "rgb(var(--dim))" }}>
            <tr className="text-left">
              <th className="px-4 py-3 font-normal whitespace-nowrap">Name</th>
              <th className="px-4 py-3 font-normal whitespace-nowrap">Email</th>
              <th className="px-4 py-3 font-normal whitespace-nowrap">Tier</th>
              <th className="px-4 py-3 font-normal whitespace-nowrap">Flights</th>
              <th className="px-4 py-3 font-normal whitespace-nowrap">Lifetime Value</th>
              <th className="px-4 py-3 font-normal whitespace-nowrap">Last flight</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((c) => (
              <tr key={c.id} style={{ borderTop: "1px solid rgb(var(--ln))" }} data-testid={`client-${c.id}`}>
                <td className="px-4 py-3 text-[rgb(var(--fg))] max-w-[220px] truncate" title={c.full_name}>{c.full_name}</td>
                <td className="px-4 py-3 text-[rgb(var(--dim))] max-w-[260px] truncate" title={c.email}>{c.email}</td>
                <td className="px-4 py-3 capitalize whitespace-nowrap">{c.vip_tier}</td>
                <td className="px-4 py-3 whitespace-nowrap">{c.flights_count}</td>
                <td className="px-4 py-3 whitespace-nowrap">{fmtUSD(c.lifetime_value_usd)}</td>
                <td className="px-4 py-3 text-[rgb(var(--dim))] whitespace-nowrap">{c.last_flight_at ? fmtTime(c.last_flight_at) : "—"}</td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan={6} className="px-4 py-10 mono text-[12px] text-[rgb(var(--dim))] text-center">
                <Users size={18} className="inline mb-2 block mx-auto text-[rgb(var(--muted-2))]" />
                No clients yet. They're auto-created on first booking.
              </td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
